import CallToAction from '../components/AboutPage/CallToAction';
import HeroSection from '../components/AboutPage/HeroSection';
import MissionSection from '../components/AboutPage/MissionSection';
import WhatWeDoSection from '../components/AboutPage/WhatWeDoSection';
import UnderConsruction from '../components/UnderConsruction';

export default function AboutUsPage() {
    return (
        <div className="pb-4 sm:pb-8 bg-gray-50">
            {/* <UnderConsruction /> */}
            <HeroSection />
            {/* <MissionSection /> */}
            <WhatWeDoSection />
            <CallToAction />
        </div>
    );
}
